module.exports = __webpack_public_path__ + "static/media/ic_kyc_under_process.3dcf31e9.svg";